import { Controller } from "@hotwired/stimulus"

// Two-step dependent selects: a parent <select> (e.g. an Audio Mix) populates a
// child <select> (e.g. that mix's tracks) from a grouped map — so the child
// list stays short instead of one giant flat list of every track.
//
// Markup:
//   <div data-controller="linked-select"
//        data-linked-select-groups-value='{"1":[["Track A (2:34)","10"]]}'>
//     <select data-linked-select-target="parent"
//             data-action="change->linked-select#populate">…mixes…</select>
//     <select name="audio_mix_track_id"
//             data-linked-select-target="child" data-selected="10"></select>
//   </div>
export default class extends Controller {
  static targets = ["parent", "child"]
  static values = { groups: Object }

  connect() {
    this.populate()
  }

  populate() {
    const key = this.parentTarget.value
    const options = this.groupsValue[key] || []
    const current = this.childTarget.dataset.selected || ""

    this.childTarget.replaceChildren(new Option("— choose a track —", ""))
    options.forEach(([label, value]) => {
      const option = new Option(label, String(value))
      if (String(value) === current) option.selected = true
      this.childTarget.add(option)
    })
  }
}
